module.exports = __webpack_public_path__ + "zespol_07.jpg?3303b715a9c287a91c5bb0a7fb2654eb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zespol_07.jpg
// module id = 152
// module chunks = 0